<template>
  <div id="app-layout">
    <el-header id="topHeader" height="56px">
      <Header />
    </el-header>
    <div id="bodyWrap">
      <el-aside id="leftNav" width="280px">
        <Nav />
      </el-aside>
      <el-main id="main">
        <router-view :key="key"/>
      </el-main>
    </div>
  </div>
</template>

<script>
import Nav from "./Nav.vue";
import Header from "./Header.vue";

export default {
  name: "Layout",
  components: {Header, Nav},
  data(){
    return {}
  },
  computed: {
    key() {
      return this.$route.fullPath
    }
  }
}
</script>

<style scoped>
#app-layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
#topHeader {
  height: 56px;
  background: #FFFFFF;
  border-bottom: 1px solid #EDF0F2;
  padding: 0 0 0 24px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  z-index: 10;
}
#bodyWrap {
  flex: 1;
  display: flex;
  overflow: hidden;
}
#leftNav {
  width: 280px;
  min-height: 100%;
  background: #FFFFFF;
  overflow-y: hidden;
  flex-shrink: 0;
}
#main {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #F6F7F8;
}
</style>
